import { h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import UserName from '../User/UserName'
import Loader from '../../control-components/ui-components/Loader'
import Phrase from '../../libs/translationsUtils/phrase'

export interface UserData {
  id: string,
  name: string,
  avatar: string,
  rank?: {
    name: string,
    avatarIconUrl: string,
    isBold: boolean,
    isItalic: boolean,
    isUnderline: boolean,
    color: string
  }
}

interface AttendeeProps {
  eventId: number,
  attendeeCount: number,
  attendees: Array<UserData>,
  page: number,
  isLoading: boolean,
  loadNextPage: () => void,
  isEventEngagementEnabled: boolean,
  isPastEvent: boolean
}

const EventAttendees = ({ attendeeCount, attendees, page, isLoading, loadNextPage, isEventEngagementEnabled, isPastEvent }: AttendeeProps) => {
  const hideShowMoreButton = page * 6 >= attendeeCount
  if (!isEventEngagementEnabled) return null
  if (isPastEvent && attendeeCount === 0) return null

  return <div className='event-attendees-container'>
    <div className='event-attendees__header_label'><Phrase p='events.attendees' m='Forum' /> ({attendeeCount})</div>
    <div className='event__attendees'>
      {
        attendees.map(attendee => <div className='attendee'><UserAvatar user={attendee} showRank />
          <div>
            <UserName user={attendee} />
            { attendee.rank ? <div className='text--meta'>{attendee.rank.name}</div> : null }
          </div>
        </div>)
      }
      { attendees.length === 0 && <div className='no-attendees-placeholder'><Phrase p='events.attendees.none' m='Forum' /></div>}
      { isLoading ? <Loader /> : null }
    </div>
    { hideShowMoreButton ? null : <div className='show-more-attendees'><a onClick={() => loadNextPage()}>Show more</a></div> }
  </div>
}

export default EventAttendees
